import { IdCardsComponent } from '../../routes/id-cards/id-cards.component';
import { MapfreCardComponent } from '../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { PolicyDataService } from '@services/data-services/policy-data.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, IdCardsComponent],
  selector: 'app-id-cards-wrapper',
  templateUrl: './id-cards-wrapper.component.html'
})
export class IdCardsWrapperComponent implements OnInit {

  policyDetails: any;
  constructor(
    private policyDataService: PolicyDataService
  ) { }

  ngOnInit(): void {
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse) {
        this.policyDetails = this.policyDataService.getActiveAutoPolicies(policyResponse);
      }
    });
  }

}
